import tlds from 'tlds';
import LinkifyIt from 'linkify-it';
import { useTranslation } from 'react-i18next';
import { Label, Textarea } from '@anytag/shared-atoms';
import { cn } from '@anytag/shared-utils';

interface LinkifyItInputProps {
  value: string;
  onChange: (value: string) => void;
}
export const LinkifyItInput = ({ value, onChange }: LinkifyItInputProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <Textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t<string>('draftPostModificationPlaceholder')}
        className="mt-2 h-28.5 whitespace-pre-line"
      />

      <Label title={t('Preview')} className="mt-4 text-base font-normal" />
      <LinkifyItPreview value={value} className="mt-2" />
    </div>
  );
};

export const LinkifyItPreview = ({ value, className }: { value: string; className?: string }) => {
  const linkify = new LinkifyIt();
  linkify.tlds(tlds);

  // Function to convert text with URLs into clickable links
  const parseText = (text: string) => {
    const matches = linkify.match(text);
    if (!matches) return text;

    let lastIndex = 0;
    const elements = [];

    matches.forEach((match, index) => {
      // Add text before the link
      if (match.index > lastIndex) {
        elements.push(<span key={`text-${index}`}>{text.slice(lastIndex, match.index)}</span>);
      }

      // Add the link
      elements.push(
        <a
          key={`link-${index}`}
          href={match.url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'blue', textDecoration: 'underline', display: 'inline' }}
        >
          {match.text}
        </a>
      );

      lastIndex = match.lastIndex;
    });

    // Add remaining text after the last link
    if (lastIndex < text.length) {
      elements.push(' ' + text.slice(lastIndex));
    }

    return elements;
  };

  return (
    <div
      className={cn(
        'max-h-100 overflow-auto rounded-sm border-base-border bg-white px-3 py-2 text-base whitespace-break-spaces',
        className
      )}
    >
      {parseText(value)}
    </div>
  );
};
